import {
    createBrowserRouter, createRoutesFromElements, Navigate, Route,
} from "react-router-dom";
import Layout from "../components/Layout";
import { DynamicRedirect } from "./DynamicRedirect";

import Dashboard from "../pages/applicant/Dashboard";
import NotFound from "../pages/applicant/NotFound";
import ResponsibleAdults from "../pages/applicant/ResponsibleAdults";
import Support from "../pages/applicant/Support";
import StudentDetails from "../pages/applicant/StudentDetails";
import PreviousEducation from "../pages/applicant/PreviousEducation";
import EnrolmentAgreement from "../pages/applicant/EnrolmentAgreement";
import CourseSelection from "../pages/applicant/CourseSelection";
import TuitionBilling from "../pages/applicant/TuitionBilling";
import ConsultationCall from "../pages/applicant/ConsultationCall";
import AuthAndStudentsLayout from "./AuthAndStudentsLayout";
import DocusignComplete from "../pages/applicant/DocusignComplete";

import StudentHome from "../pages/student/Home";
import StudentHub from "../pages/student/StudentHub";
import Community from "../pages/student/Community";
import Academic from "../pages/student/Academic";
import SupportingLearning from "../pages/student/SupportingLearning";
import Finance from "../pages/student/Finance";
import { Contracts } from "../pages/student/Finance/pages/Contracts";
import { Payments } from "../pages/student/Finance/pages/Payments";
import { RenewalPayment } from "../pages/student/Renewals/pages/RenewalPayment";
import { RollingRenewals } from "../pages/student/Finance/pages/RollingRenewals";
import { Calendar } from "../pages/student/StudentHub/pages/Calendar";
import { TeachingGroups } from "../pages/student/StudentHub/pages/TeachingGroups";
import { Timetable } from "../pages/student/StudentHub/pages/Timetable";
import { ExtraCurriculurActivities } from "../pages/student/Community/pages/ExtraCurriculurActivities";
import { BookCommunicationPeriod } from "../pages/student/Community/pages/BookCommunicationPeriod";
import { SchoolReports } from "../pages/student/Academic/pages/SchoolReports";
import { RewardsConcerns } from "../pages/student/Academic/pages/RewardsConcerns";
import { GradeBooks } from "../pages/student/Academic/pages/GradeBooks";
import { AbsenceRequests } from "../pages/student/Academic/pages/AbsenceRequests";
import { HistoricalAbsences } from "../pages/student/Academic/pages/HistoricalAbsences/HistoricalAbsences";
import { AttendanceSummary } from "../pages/student/Academic/pages/AttendanceSummary";
import { ITP } from "../pages/student/SupportingLearning/pages/ITP";
import { ContributionLevels } from "../pages/student/SupportingLearning/pages/ContributionLevels";
import { EnrolAdditionalServices } from "../pages/student/SupportingLearning/pages/EnrolAdditionalServices";
import { ExamInformation } from "../pages/student/SupportingLearning/pages/ExamInformation";
import MyDetails from "../pages/student/MyDetails";
import AddStudent from "../pages/AddStudent";
import { InvoicePay } from "../pages/student/Finance/pages/InvoicePay";
import Renewals from "../pages/student/Renewals";
import Alumni from "../pages/alumni/Alumni";
import ReEnrolment from "../pages/alumni/ReEnrolment";
import { RenewalContract } from "../pages/student/Renewals/pages/RenewalContract";
import { Assessments } from "../pages/student/SupportingLearning/pages/Assessments";
import ExamsInformation from "../pages/student/ExamsInformation";
import MentorPathway from "../pages/student/MentorPathway";
import SessionNotes from "../pages/student/MentorPathway/pages/SessionNotes/SessionNotes";
import StudentProfileForm from "../pages/student/MentorPathway/pages/StudentProfileForm";
import { ExamSupport } from "../pages/student/ExamsInformation/pages/ExamSupport";

export const router = createBrowserRouter(
    createRoutesFromElements(
        <Route>
            <Route element={<AuthAndStudentsLayout />}>
                <Route element={<Layout withStudents />}>
                    <Route path="/" element={<DynamicRedirect />} />
                    <Route path="/impersonate/:token" element={<DynamicRedirect />} />

                    {/* Applicant Routes */}
                    <Route path="/dashboard/:studentId?" element={<Dashboard />} />
                    <Route path="/responsible-adults/:studentId?" element={<ResponsibleAdults />} />
                    <Route path="/student-details/:studentId?" element={<StudentDetails />} />
                    <Route path="/previous-education/:studentId?" element={<PreviousEducation />} />
                    <Route path="/enrolment-agreement/:studentId?" element={<EnrolmentAgreement />} />
                    <Route path="/consultation-call/:studentId?" element={<ConsultationCall />} />
                    <Route path="/course-selection/:studentId?" element={<CourseSelection />} />
                    <Route path="/tuition-billing/:studentId?" element={<TuitionBilling />} />

                    {/* Student Routes */}
                    <Route path="/home/:studentId?" element={<StudentHome />} />

                    <Route path="student-hub">
                        <Route path=":studentId?" element={<StudentHub />} />
                        <Route path="timetable/:studentId?" element={<Timetable />} />
                        <Route path="teaching-groups/:studentId?" element={<TeachingGroups />} />
                        <Route path="calendar/:studentId?" element={<Calendar />} />
                    </Route>

                    <Route path="community">
                        <Route path=":studentId?" element={<Community />} />
                        <Route path="extra-curriculur-activities/:studentId?" element={<ExtraCurriculurActivities />} />
                        <Route path="book-communication-period/:studentId?" element={<BookCommunicationPeriod />} />
                    </Route>

                    <Route path="academic">
                        <Route path=":studentId?" element={<Academic />} />
                        <Route path="school-reports/:studentId?" element={<SchoolReports />} />
                        <Route path="rewards-concerns/:studentId?" element={<RewardsConcerns />} />
                        <Route path="grade-books/:studentId?" element={<GradeBooks />} />
                        <Route path="absence-requests/:studentId?" element={<AbsenceRequests />} />
                        <Route path="historical-absences/:studentId?" element={<HistoricalAbsences />} />
                        <Route path="attendance-summary/:studentId?" element={<AttendanceSummary />} />
                    </Route>

                    <Route path="supporting-learning">
                        <Route path=":studentId?" element={<SupportingLearning />} />
                        <Route path="itp/:studentId?" element={<ITP />} />
                        <Route path="contribution-levels/:studentId?" element={<ContributionLevels />} />
                        <Route path="enrol-additional/:studentId?" element={<EnrolAdditionalServices />} />
                        <Route path="exam-information/:studentId?" element={<ExamInformation />} />
                        <Route path="assessments/:studentId?" element={<Assessments />} />
                    </Route>

                    <Route path="finance">
                        <Route path=":studentId?" element={<Finance />} />
                        <Route path="payments/:studentId?" element={<Payments />} />
                        <Route path="pay/:invoiceId/:studentId?" element={<InvoicePay />} />
                        <Route path="contracts/:studentId?" element={<Contracts />} />
                        <Route path="rollingRenewals/:studentId?" element={<RollingRenewals />} />
                    </Route>

                    <Route path="renewals">
                        <Route path=":studentId?" element={<Renewals />} />
                        <Route path="payment/:studentId?" element={<RenewalPayment />} />
                        <Route path="contract/:studentId?" element={<RenewalContract />} />
                    </Route>

                    <Route path="mentor-pathway">
                        <Route path=":studentId?" element={<MentorPathway />} />
                        <Route path="session-notes/:studentId?" element={<SessionNotes />} />
                        <Route path="student-profile-form/:studentId?" element={<StudentProfileForm />} />
                    </Route>

                    <Route path="exams-information">
                        <Route path=":studentId?" element={<ExamsInformation />} />
                        <Route path="exam-support/:studentId?" element={<ExamSupport />} />
                    </Route>
                </Route>
                <Route element={<Layout />}>
                    <Route path="/my-details" element={<MyDetails />} />
                    <Route path="/support" element={<Support />} />
                    <Route path="/alumni" element={<Alumni />} />
                    <Route path="/alumni/:studentId" element={<ReEnrolment />} />
                    <Route path="/add-student/new" element={<AddStudent />} />
                    <Route path="*" element={<NotFound />} />
                </Route>
            </Route>
            <Route path="/docusign-complete" element={<DocusignComplete />} />
        </Route>,
    ),
);
